import React from "react";
import ReactDOM from "react-dom";
// import App from "./App";
import { App } from "./components/App/index";
import "./css/index.css";

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById("root")
);
